import axios from "axios";

const { REACT_APP_FLASK_API_URL } = process.env;

const createPotentialClient = async(data) => {
   const response = await axios
     .post(`${REACT_APP_FLASK_API_URL}/potential-clients`, data)
   
   return response;
 };

 export default createPotentialClient